let isChatwootLoaded = false;

export default defineNuxtPlugin(() => {
    if (!import.meta.client || isChatwootLoaded) {
        return;
    }

    const config = useRuntimeConfig();
    if (!config.public.chatWootToken) {
        return;
    }

    const loadChatwoot = () => {
        if (isChatwootLoaded) {
            return;
        }

        const BASE_URL = "https://cs.tripening.com";
        const script = document.createElement("script");
        script.src = `${BASE_URL}/packs/js/sdk.js`;
        script.defer = true;
        script.async = true;
        script.setAttribute("data-loaded-by", "chatwoot-plugin");

        script.onload = () => {
            isChatwootLoaded = true;
        };

        document.head.appendChild(script);
    };

    if ("requestIdleCallback" in window) {
        window.requestIdleCallback(loadChatwoot, { timeout: 3000 });
    } else {
        window.setTimeout(loadChatwoot, 1000);
    }
});
